diy.angular.registerFactory('diyfmfolders', ['$resource', 'diywebsiteid', function($resource, diywebsiteid) {
    return $resource('/rest/websites/' + diywebsiteid + '/storage-folders/:id', {
            id: '@id'
         }, {
            'create':   {method:'POST'},
            'update': {method: 'PUT'}
        }
    );
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmfolders.js
 ** module id = 937
 ** module chunks = 0
 **/